import { FC } from "react";
import styles from "./NoDataAvailable.module.less";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Typography } from "antd";

interface NoDataAvailableProps {
  title?: string;
  text?: string;
  style?: React.CSSProperties;
}

export const NoDataAvailable: FC<NoDataAvailableProps> = ({
  title = "No Data Available",
  text,
  style,
}) => {
  return (
    <div className={styles.noDataAvailable} style={style}>
      <div>
        <InfoCircleOutlined style={{ fontSize: 36 }} />
      </div>
      <div className={styles.textContainer}>
        {title && (
          <Typography.Text className={styles.title}>{title}</Typography.Text>
        )}
        {text && (
          <Typography.Text className={styles.text}>{text}</Typography.Text>
        )}
      </div>
    </div>
  );
};
